<template lang="html">

  <VqModal
    :name="modalName"
    class="vq-modal-delete-vm">
    <template v-slot:header>
      <h2 class="modal-title">{{setTitleContext($t('components.modalDeleteVm.del'))}} <span class="is-bold">{{ $t('components.modalDeleteVm.vm') }} {{vmName}}</span></h2>
      <button
        type="button"
        class="button is-square is-rounded is-xsmall is-gray-100 modal-close"
        v-on:click="close">
        <span class="css-icon is-close"></span>
      </button>
    </template>
    <template v-slot:content>
  <div class="forms">
    <form>
      <div class="container has-separator">
        <div class="row">
            <p class="pb-5">
              {{ $t('components.modalDeleteVm.title') }} "<span class="is-bold">{{vmName}}</span>"
            </p>
            <p class="is-thin">{{ $t('components.modalDeleteVm.content') }}</p>

            <p class="pt-10">{{ $t('components.modalDeleteVm.type') }}</p>
            <VqInput
                classes="col-tab-12 mt-10 is-center-aligned"
                :label="$t('components.modalDeleteVm.form.label')"
                name="cn"
                type="text"
                v-model="vmNameValid"
            />
        </div>
      </div>
      <div class="container has-separator">
        <div class="row">
          <div>
            <p class="pb-5">{{ $t('components.modalDeleteVm.title2') }}</p>
            <p class="is-thin">{{ $t('components.modalDeleteVm.content2') }}</p>
            <VqRadio
              :options="radioOptions"
              :default="radioDefault"
              name='deleteVm'
              :model.sync="radioData"
            />
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<template v-slot:footer>
  <button type="button" class="button is-small is-gray-400" v-on:click="close">{{ $t('components.modalDeleteVm.cancel') }}</button>
  <button
    v-if="$store.state.display_edit && vmNameValid == vmName && $store.state.otrs_is_active"
    type="button"
    class="button is-small is-danger is-outline"
    :class="{'is-loading': loading}"
    @click="submit">{{ $t('components.modalDeleteVm.delete') }}
  </button>
</template>
</VqModal>

</template>

<script lang="js">

import { eventHubMixin } from '@/mixins/event';

import VSPHERE from '@/api/vsphere';

import VqModal from '@/components/VqModal.vue';
import VqRadio from '@/components/VqRadio.vue';
import VqInput from '@/components/VqInput.vue';


export default {
  name: 'ModalDeleteVm',
  mixins: [eventHubMixin],
  components: {
    VqModal,
    VqRadio,
    VqInput,
  },

  data() {
    return {
      modalName: 'delete-vm',
      context: 'delete',
      vmName: '',
      vmNameValid: '',
      radioOptions: [
        {
          label: this.$t('components.modalDeleteVm.form.yes'),
          value: true,
        },
        {
          label: this.$t('components.modalDeleteVm.form.no'),
          value: false,
        },
      ],
      radioDefault: 'No',
      radioData: { value: false },
      deleteModalData: {
        vm_name: '',
        certificate: '',
        price: 0,
      },
      price: 0,
      loading: false
    };
  },
  mounted() {
    this.onOpenModal(this.modalName, (data) => {
      this.vmName = data.name
      this.price = data.price
    });
  },
  methods: {
    submit() {
      this.loading = true
      this.deleteModalData.vm_name = this.vmName
      this.deleteModalData.certificate = this.radioData.value
      this.deleteModalData.price = this.price
      VSPHERE.deleteVm(this.deleteModalData).then(
        (res) => {
          this.close();
          this.emitToaster(this.vmName)
          this.loading = false
        },
        (err) => {
          Object.assign(this.errors, err.response.data)
        },
      );
    },
    close() {
      this.emitCloseModal(this.modalName)
    },
    setTitleContext(title) {
      return title.charAt(0).toUpperCase() + title.slice(1)
    },

    emitToaster(vmName) {
      this.emitAddToaster({
        title: this.$t('components.modalDeleteVm.toasts.title'),
        text: `${this.$t('components.modalDeleteVm.toasts.content')} ${vmName} ${this.$t('components.modalDeleteVm.toasts.content2')}`,
        state: 'success',
        // 'link': 'http://telecloud.fr'
      });
    },
  },
  computed: {

  },
};
</script>

<style scoped lang="scss">
.vq-modal-delete-vm {
}
</style>
